import React, { ReactNode } from 'react';
import './Toolbar.less';
import BackButton from '../../../screens/common/BackButton/BackButton';

const Toolbar = ({ title, toolbarButtons, showBackButton = false }: { title?: string; toolbarButtons?: ReactNode | undefined; showBackButton?: boolean }) => {
    // Layout is a 3-column grid: [back] [title] [actions] via grid-template-columns in Toolbar.less
    // (auto | minmax(0, 1fr) | auto). The title column is minmax(0, 1fr), whose implicit min:0 lets the
    // title shrink and truncate with an ellipsis regardless of how many buttons toolbarButtons contains and
    // regardless of any flex ancestors (a plain flex chain would leak min-width:auto and never truncate).
    // The actions column is auto-sized to its content, so the buttons never overlap the title.
    // On desktop the BackButton renders null (see BackButton.tsx: !isCompactLayout); the empty first column
    // collapses to 0, so the left-aligned title reads flush-left. On mobile the title is centered.

    return (
        <div className="toolbar h-12 mb-3 grid items-center" role={'toolbar'}>
            {showBackButton && (
                <div className={'col-start-1 pr-2'}>
                    <BackButton />
                </div>
            )}
            <h2 className={'col-start-2 min-w-0 truncate text-center sm:text-left px-2 mx-2 sm:px-0 sm:mx-0'}>{title}</h2>
            {toolbarButtons && <div className={'toolbar--actions col-start-3 flex flex-row justify-end items-end gap-1 pl-2'}>{toolbarButtons}</div>}
        </div>
    );
};

export default Toolbar;
